<template>
  <v-layout v-resize="onResize" column>
    <v-data-table flat
      :headers="headers"
      :items="resources"
      class="elevation-2"
      :loading="isLoading"
      :total-items="resourcesCount"
      :rows-per-page-items="limitOptions"
      :pagination.sync="pagination"
      :hide-headers="isMobile" :class="{mobile: isMobile}"
      click:row
    >
      <template slot="items" slot-scope="props">
       <tr v-if="!isMobile">
                  <td class="text-xs-left">{{ props.item.id }}</td>
                  <td class="text-xs-left">{{ $n((props.item.amount/100), 'currency') }}</td>
                  <td class="text-xs-left">{{ setDateFormat(props.item.due_date) }}</td>
                  <td class="text-xs-left">{{ setDateFormat(props.item.last) }}</td>
                  <td class="text-xs-left">{{ setDateFormat(props.item.next) }} </td>
                  <td class="text-xs-left">{{ props.item.total_payments }}</td>
                  <td class="text-xs-left">{{ props.item.cardHolderName }}</td>
                  <td class="text-xs-left">{{ props.item.pan.substr(11, 15) }}</td>
                  <td class="text-xs-left">
                  <v-chip :class="setClass(props.item.actived)" small text-color="white">
                  {{ $t(`actived.${props.item.actived}`) }}
                </v-chip>
                  </td>
                  <td class="text-xs-left">{{ setDateFormat(props.item.final_date) }}</td>
                  <td class="text-xs-left">{{ setDateFormat(props.item.created_at) }}</td>
                    <td class="text-xs-right">
                    <v-btn small color="blue" outline :to="{ name: 'subscription', params: { id: props.item.id }}" >
                      Exibir
                    </v-btn>
                    </td>
                    <td class="text-xs-right">
                      <v-btn small color="green" outline :to="{ name: 'update-subscription', params: { id: props.item.id }}" >
                        Editar
                      </v-btn>
                    </td>
                    <td class="text-xs-left">
                      <v-btn small color="red" outline @click="showCancelPopUp(props.item)">
                        Cancelar
                      </v-btn>
                      </td>
                </tr>
                <tr v-else>
                  <td>
                    <ul class="flex-content">
                      <li class="flex-item" data-label="ID">{{ props.item.id }}</li>
                      <li class="flex-item" data-label="Valor">{{ $n((props.item.amount/100), 'currency') }}</li>
                      <li class="flex-item" data-label="Vencimento">{{ setDateFormat(props.item.due_date) }}</li>
                      <li class="flex-item" data-label="Último pagamento">{{ setDateFormat(props.item.last) }}</li>
                      <li class="flex-item" data-label="Próximo pagamento">{{ setDateFormat(props.item.next) }}</li>
                      <li class="flex-item" data-label="Total de pagamentos">{{ props.item.total_payments }}</li>
                      <li class="flex-item" data-label="Nome no Cartão">{{ props.item.cardHolderName }}</li>
                      <li class="flex-item" data-label="Ultimos digitos do cartão">{{ props.item.pan.substr(11, 15) }}</li>
                      <li class="flex-item" data-label="Status">
                        <v-chip :class="setClass(props.item.actived)" small text-color="white">
                          {{ $t(`actived.${props.item.actived}`) }}
                        </v-chip>
                      </li>
                      <li class="flex-item" data-label="Válido até">{{ setDateFormat(props.item.final_date) }}</li>
                      <li class="flex-item" data-label="Criado em">{{ setDateFormat(props.item.created_at) }}</li>
                      <li class="flex-item" data-label="Detalhes">
                        <v-btn small color="blue" outline :to="{ name: 'subscription', params: { id: props.item.id }}" >
                          Exibir
                        </v-btn>
                      </li>
                      <li class="flex-item" data-label="Editar">
                        <v-btn small color="green" outline :to="{ name: 'update-subscription', params: { id: props.item.id }}" >
                          Editar
                        </v-btn>
                      </li>
                      <li class="flex-item" data-label="Cancelar">
                        <v-btn small color="red" outline @click="showCancelPopUp(props.item)">
                          Cancelar
                        </v-btn>
                      </li>
                    </ul>
                  </td>
                </tr>

      </template>
    </v-data-table>
    <v-dialog v-model="cancelDialog.show" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Cancelar Pagamento Recorrente?</v-card-title>
        <v-card-text>Você tem certeza que deseja cancelar o pagamento recorrente de identificador {{cancelDialog.id}} e com valor de {{$n((cancelDialog.amount/100), 'currency')}} ?</v-card-text>
        <v-card-actions>
          <v-btn dark color="blue" block center @click="cancelDialog.show = false">Não</v-btn>
          <v-btn dark color="red" block center @click="cancelSubscription">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { changed } from '@/helpers/layout';

export default {
  props: ['row'],
  mounted() {
    this.$store.dispatch('invoices/loadSubscriptions', this.filters);
  },
  computed: {
    ...mapGetters({
      resources: 'invoices/subscriptionsList',
      resourcesCount: 'invoices/subscriptionsResourcesCount',
      limitOptions: 'invoices/subscriptionsLimitOptions',
      currentPage: 'invoices/subscriptionsCurrentPage',
      filters: 'invoices/subscriptionsFilter',
      isLoading: 'invoices/subscriptionsLoadingData',
    }),
    pages() {
      return 0;
    },
  },
  components: {

  },
  watch: {
    pagination: function pagination(newPagination, oldPagination) {
      if( changed(newPagination.rowsPerPage, oldPagination.rowsPerPage) ) {
        this.setLimit(newPagination.rowsPerPage);
        this.$store.dispatch('invoices/loadSubscriptions', this.filters);
      }
      if( changed(newPagination.page, oldPagination.page) ) {
        this.setCurrentPage(newPagination.page);
        this.$store.dispatch('invoices/loadSubscriptions', this.filters);
      }
    },
  },
  methods: {
    ...mapActions({
      setCurrentPage: 'invoices/setSubscriptionsCurrentPage',
      setLimit: 'invoices/setSubscriptionsLimit',

    }),
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    setClass(status) {
      return `invoice ${status}`;
    },
    showCancelPopUp(row) {
      this.cancelDialog.show = true;
      this.cancelDialog.desc = row.subscription;
      this.cancelDialog.amount = row.amount
      this.cancelDialog.id = row.id;
    },
    cancelSubscription() {
      this.$store.dispatch('invoices/cancelSubscription', this.cancelDialog.id);
      this.cancelDialog.show = false;
      window.location.reload();
    },
    setDateFormat(date) {
      if (date === null) {
        return ''
      } else {
        return new Date(date).toLocaleDateString("pt-BR")
      }
    }

  },
  data() {
    return {
      items: [],
      count: 0,
      pagination: {},
      isMobile: false,
      cancelDialog: {
        show: false,
        amount: 0,

        id: 0,
        desc: ''
      },
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Valor', value: 'amount' },
        { text: 'Vencimento', value: 'due_date' },
        { text: 'Último pagamento', value: 'last' },
        { text: 'Próximo pagamento', value: 'next' },
        { text: 'Total de pagamentos', value: 'total_payments' },
        { text: 'Nome no Cartão', value: 'cardHolderName' },
        { text: 'Ultimos digitos do cartão', value: 'pan' },
        { text: 'Status', value: 'actived' },
        { text: 'Válido até', value: 'final_date' },
        { text: 'Criado em', value: 'created_at' },
        { text: 'Detalhes', value: 'actions', sortable: false },
        { text: 'Editar', value: 'edit', sortable: false },
        { text: 'Cancelar', value: 'cancel', sortable: false },
      ],
    };
  },
};
</script>
<style>
.mobile {
      color: #333;
    }

    @media screen and (max-width: 768px) {
      .mobile table.v-table tr {
        max-width: 100%;
        position: relative;
        display: block;
      }

      .mobile table.v-table tr:nth-child(odd) {
        border-left: 6px solid #b2b2b8;
      }

      .mobile table.v-table tr:nth-child(even) {
        border-left: 6px solid cyan;
      }

      .mobile table.v-table tr td {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #636366;
        height: auto;
        padding: 10px;
      }

      .mobile table.v-table tr td ul li:before {
        content: attr(data-label);
        padding-right: .5em;
        text-align: left;
        display: block;
        color: #999;

      }
      .v-datatable__actions__select
      {
        width: 50%;
        margin: 0px;
        justify-content: flex-start;
      }
      .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
        background: transparent;
      }

    }
    .flex-content {
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }

    .flex-item {
      padding: 5px;
      width: 50%;
      height: 40px;
      font-weight: bold;
      margin-top: 10px;
    }
  .v-chip.invoice.false    { background-color: #B71C1C !important; }
  .v-chip.invoice.true    { background-color: #1B5E20 !important; }
</style>
